import {Component, EventEmitter, Input, OnInit, Output} from "@angular/core";
import {DeviceCart, OrderHistory} from "@kion/data-models";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {BehaviorSubject} from "rxjs";
import {debounceTime} from "rxjs/operators";

@Component({
    selector: 'kion-cms-order-history-quote',
    templateUrl: './order-history-quote.component.html',
    styleUrls: ['./order-history-quote.component.scss'],
})
export class OrderHistoryQuoteComponent implements OnInit {
    readonly orderHistory$ = new BehaviorSubject<OrderHistory | undefined>(undefined);
    readonly deviceCart$ = new BehaviorSubject<DeviceCart | undefined>(undefined);

    @Input() set orderHistory(val: OrderHistory | undefined) {
        if (val) {
            this.orderHistory$.next(val);
        }
    }

    @Input() set deviceCart(val: DeviceCart | undefined) {
        if (val) {
            this.deviceCart$.next(val);
        }
    }

    @Input() canEdit: boolean;

    @Output() readonly formChange = new EventEmitter<[string, string]>();


    form: FormGroup;

    constructor(
        formBuilder: FormBuilder
    ) {
        this.form = formBuilder.group({
            poNumber: new FormControl(null),
            poNote: new FormControl(null),
        });
    }


    ngOnInit() {
        this.orderHistory$.subscribe((orderHistroy) => {
            if (orderHistroy) {
                const poNumber = this.form.get('poNumber');
                const poNote = this.form.get('poNote');
                if (!poNumber.value) {
                    poNumber.patchValue(orderHistroy.purchaseOrderNumber, { emitEvent: false });
                }
                if (!poNote.value) {
                    poNote.patchValue(orderHistroy.userComment?.text,  { emitEvent: false });
                }
            }
        })

        this.form.get('poNumber').valueChanges.pipe(debounceTime(500))
            .subscribe(() => {
                this.formChange.emit([this.form.controls['poNumber'].value, this.form.controls['poNote'].value]);
            });
        this.form.get('poNote').valueChanges.pipe(debounceTime(500))
            .subscribe(() => {
                this.formChange.emit([this.form.controls['poNumber'].value, this.form.controls['poNote'].value]);
            });
    }

}